import { render, staticRenderFns } from "./EditColumnInput.vue?vue&type=template&id=9f4b5818"
import script from "./EditColumnInput.vue?vue&type=script&lang=js"
export * from "./EditColumnInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports